<template>
  <div class="TransferStatuses__Widget" v-if="ready">
        <div class="icon">
          <b-button :loading="isLoading" @click.stop="preview()">
            <b-icon icon="download-circle" />
          </b-button>
        </div>
    <label v-for="(item, index) in filteredTransferStatusEvents" :key="index">
      <div class="transfer-header">
        <div>
          <b>{{ item.TransferStatus.Name }}</b>
        </div>
      </div>
      <div class="updated-by">
        <span class="datetime">{{ item.Date | date }}</span> | עודכן ע"י:
        <span> {{ item.UpdatingUserName ? item.UpdatingUserName : '-' }} </span>
      </div>
      <div v-if="item.BotError">
        <p style="width: 90px; margin: 0;"> {{ getEventErrorMessage(item) }} </p>
        <span> {{ item.BotError }} </span>
      </div>
      <div v-if="item.MissingDocumentsLink">
        <a :href="item.MissingDocumentsLink" target="_blank">להשלמת מסמכים</a>
      </div>
      <span class="reference" v-if="item.Reference">{{ item.Reference }}</span>
      <div class="scanned-doc" v-if="item.ScannedPdfUrl">
        <a href="#" @click.prevent="downloadFile(item.ScannedPdfUrl)" title="מסמך סרוק מהמייל">
          <b-icon icon="file-document-outline" />
        </a>
      </div>
    </label>
    <h1 v-if="!filteredTransferStatusEvents.length">אין נתוני הסבה</h1>
  </div>
</template>

<script>
import FilesService from "@/services/FilesService";
import VueIframeWritable from "@/components/VueIframeWritable.vue";
import DriverService from "@/services/DriverService";
import { ToastProgrammatic as Toast } from "buefy";
import moment from 'moment';
import printer from "../../plugins/printer";

export default {
  name: 'TransferStatusesDriverWidget',
  props: ['ready', 'namespace'],
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    filteredTransferStatusEvents() {
      const transferStatusEvents = this.$store.state[this.namespace].DriverTransferStatusEvents;
      if (transferStatusEvents) {
        const statuses = transferStatusEvents.slice(0);
        statuses.sort((a, b) => new Date(a.Date) - new Date(b.Date));
        return statuses;
      }
      return [];
    },
  },
  filters: {
    date(value) {
      const date = moment(value, 'YYYY-MM-DDThh:mm');
      return date.format('DD/MM/YYYY HH:mm');
    },
  },
  methods: {
    init() {
      this.$emit('onReady');
    },
    preview() {
      const loadingComponent = this.$buefy.loading.open();
      const scrollPosition = document.body.querySelector('.table-wrapper')?.scrollTop;
      DriverService.printTransfers([this.$store.state.report.Id])
        .then((r) => {
          this.$iframe.open({
            html: r.data?.Html,
            component: VueIframeWritable,
            onSave: async ({ close, loading }) => {
              loading(true);
              this.downloadFile(this.$store.state.report.DriverTransferPdfUrl).finally(() => {
                loading(false);
                close();
              });
            },
            onPrint: async ({ loading }) => {
              loading(true);
              printer.printHtml(r.data.Html, scrollPosition);
              loading(false);
            },
          });
        })
        .finally(() => {
          loadingComponent.close();
        });
    },
    getEventErrorMessage(event) {
      if (event.UpdatingUserName === 'transferBot') {
        if (event.BotError !== null) return 'שגיאה מהבוט:';
        return 'הודעה מהבוט:';
      }
      if (event.BotError !== null) return 'שגיאה מהAPI:';
      return 'הודעה מהAPI:';
    },
    downloadFile(url) {
      this.isLoading = true;
      return FilesService.getTransferPdf(url, {
        // headers: { "Profile-Id": this.item.Owner.Id },
      })
        .then((r) => {
          FilesService.saveResponseFile(r, "הסבה.pdf");
        })
        .catch(() => {
          Toast.open({
            type: "is-danger",
            message: "המערכת נתקלה בבעיה! יש לנסות שוב או לפנות לתמיכה הטכנית.",
            position: "is-bottom",
            duration: 8000,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  watch: {
    ready(newValue) {
      if (newValue) {
        this.init();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.TransferStatuses__Widget {
  width: 100%;
  position: relative;

  label {
    padding: 4px 6px;
    display: flex;
    flex-direction: column;

    span {
      // font-weight: 600;
      padding-left: 5px;
    }

    .updated-by {
      color: #b0b0b0;
      font-size: 0.85em;

      .datetime {
        color: #888;
      }
    }

    .reference {
      margin: 5px 0px;
    }

    .scanned-doc {
      text-align: right;
    }

  }

  .transfer-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .transfer-info {
    display: flex;
    flex-direction: column;
  }

  button {
    border: none;
    background: transparent;
  }
  > .icon {
    position: absolute;
    left: 10px;
    top: 10px;
  }
}</style>
